import React from 'react';
import { Label, Icon } from 'semantic-ui-react'

import UpdateTagsModal from '../modals/update_tags'
import TagComponent from '../tag_component'
import TraineeRole from '../role_components/trainee_role';
import ArchivedDetails from '../archived_details/archived_details';

import { validateTrainee } from '../../../helpers';

import './index.css'


class TraineesTable extends TagComponent {
  constructor(props){
    super(props);
    this.state = {
      trainees: [],
      updateModalShown: false,
      currentTrainee: {},
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if (nextProps.render){
      return true;
    }
    else {
      return false;
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.trainees !== this.props.trainees){
      this.setState({
        trainees: nextProps.trainees,
        currentTrainee: {}
      })
    }

  }

  onRemove = (evt, trainee, tagName, context) => {
    evt.stopPropagation()
    if (context === 'tags'){
      this.removeFromTagList(tagName, trainee)
    }
    else if (context === 'regions'){
      this.removeFromRegionList(tagName, trainee)
    }
  }

  showUpdateModal = (trainee) => {
    const errors = validateTrainee(trainee);
    const errorList= Object.values(errors).filter((e) => e);
    const hasInvalidDetails = errorList.length > 0;

    if (hasInvalidDetails) return;

    this.setState({
      updateModalShown: true,
      trainee: trainee
    })
  }

  onTeamClick = (evt, obj) => {
    evt.stopPropagation()
    this.props.onTeamClick(evt, obj)
  }

  onMenuEventHandler = (evt, trainee) => {
    this.props.setSelectedRow(trainee)
    var contextmenu_id
    if(trainee.archived){
      contextmenu_id = 'archived_table_row_contextmenu'
    } else {
      contextmenu_id = 'table_row_contextmenu'
    }

    evt.preventDefault();
    evt.stopPropagation();
    this.closeAllTableContextMenu()

    let element = document.getElementById(contextmenu_id);
    this.autoPositionElement(evt, element);

  }

  closeTableContextMenu = (contextmenu_id) => {
    let menu = document.getElementById(contextmenu_id);
    menu.style.cssText = 'visibility: hidden;';
  }

  closeAllTableContextMenu = () => {
    this.closeTableContextMenu('table_row_contextmenu')
    this.closeTableContextMenu('archived_table_row_contextmenu')
  }

  updateRoles = (role_list, trainee) => {
    const newTrainee = {...trainee};
    newTrainee.role_list = role_list
    this.setState({currentTrainee: newTrainee})
  }

  createNewRole = (tag) => {
    const { defaultRoleOptions } = this.props;
    if (!defaultRoleOptions.includes(tag)){
      defaultRoleOptions.unshift(tag)
    }
  }

  removeRole = (evt, trainee, role) => {
    const newTrainee = {...trainee};
    newTrainee.role_list = trainee.role_list.filter((item)=>{ return item !== role });
    this.props.updateTraineeWithValidation(newTrainee)
  }

  updateTrainee = () => {
    const { currentTrainee } = this.state;
    if (currentTrainee && currentTrainee.id) {
      this.props.updateTraineeWithValidation(currentTrainee);
    }
  }

  traineeHasRole = (trainee) => {
    return trainee.role_list && trainee.role_list.length > 0
  }

  isCurrentTrainee = (trainee) => {
    const { currentTrainee } = this.state;
    return currentTrainee && currentTrainee.id === trainee.id
  }

  render() {
    const { trainees } = this.state
    const { id, className, heading, tags, regions, defaultRoleOptions } = this.props

    return (
      <div id={id} className={`trainees-table ${className}`}>
        {
          heading &&
          <div className='trainees-table-heading '>
            { heading }
          </div>
        }
        <div className='trainees-table-head-row'>
          <div key='name' className='trainees-table-name'>Trainee Name</div>
        </div>
        {
          trainees.length > 0 &&
          trainees.map((trainee, i)=>{
            const errors = validateTrainee(trainee);
            const errorList= Object.values(errors).filter((e) => e);
            const hasInvalidDetails = errorList.length > 0;
            const hasInvalidDirectDetails = (errors.first_name || errors.last_name || errors.email);
            return(
              <div
                key={trainee.id}
                className='trainees-table-data-row'
                onClick={(evt)=>this.showUpdateModal(trainee)}
                onContextMenu={evt=>this.onMenuEventHandler(evt, trainee)}
              >
                <div key={`name-${trainee.id}`} className='trainees-table-name'>
                  <div className='fullname'>{trainee.fullname}</div>
                  {
                    trainee.email && <div className='email'>({trainee.email})</div>
                  }
                  {
                    trainee.archived && <ArchivedDetails archivedDate={trainee.archived_date} />
                  }
                  {
                    (this.traineeHasRole(trainee) || this.isCurrentTrainee(trainee))  &&
                    <TraineeRole
                      roleList={trainee.role_list}
                      roleOptions={defaultRoleOptions}
                      updateRoles={(roleList) => this.updateRoles(roleList, trainee)}
                      createNewRole={this.createNewRole}
                      removeRole={(evt, role)=>this.removeRole(evt, trainee, role)}
                      updateTrainee={this.updateTrainee}
                      doneable={true}
                      viewOnly={hasInvalidDirectDetails}
                    />
                  }
                  <div>
                    {
                      trainee.tag_list.length > 0 &&
                      trainee.tag_list.map((tag, j)=>{
                        return(
                          <Label key={tag} value={tag} onClick={(evt)=>this.onTeamClick(evt, {value: tag, tag_type:'custom-tag'})}>
                            {tag} { !hasInvalidDetails && <Icon id='team-tag' name='close' onClick={(evt)=>this.onRemove(evt, trainee, tag, 'tags')}/> }
                          </Label>
                        )
                      })
                    }
                    {
                      trainee.region_list.length > 0 &&
                      trainee.region_list.map((region, j)=>{
                        return(
                          <Label className='region' key={region} value={region} onClick={(evt)=>this.onTeamClick(evt, {value: region, tag_type:'region-tag'})}>
                            {region} { !hasInvalidDetails && <Icon id='team-tag' name='close' onClick={(evt)=>this.onRemove(evt, trainee, region, 'regions')}/> }
                          </Label>
                        )
                      })
                    }
                  </div>
                </div>
                {
                  <div className='trainees-table-action three-dots' onClick={evt=>this.onMenuEventHandler(evt, trainee)}>
                    <Icon name='ellipsis vertical'/>
                  </div>
                }
              </div>
            )
          })
        }
        {
          trainees.length === 0 && !this.props.fetchingTrainees &&
          <div className='trainees-table-no-result'>
            No result found.
          </div>
        }
        {
          this.state.updateModalShown &&
          <UpdateTagsModal
            show={this.state.updateModalShown}
            onClose={()=>this.setState({ updateModalShown: false })}
            tags={tags}
            regions={regions}
            tagged_item={this.state.trainee}
            updateTags={this.props.updateTags}
          />
        }
      </div>
    )
  }
}

export default TraineesTable;



// WEBPACK FOOTER //
// ./src/views/components/tables/v2_trainees_table.js